import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CommonControlsModule } from '../common-controls/common-controls.module';
import { RomeLibraryModule } from '../lib/rome-library.module';
import { RomeKendoModule } from '../rome-kendo/rome-kendo.module';

import { AddCaseComponent } from './components/add-case/add-case.component';
import { AdvisedResidentialQuestionsComponent } from './components/advised-residential-questions/advised-residential-questions.component';
import { BuyToLetQuestionsComponent } from './components/buy-to-let-questions/buy-to-let-questions.component';
import { AdvisedEligibilityValidatorService } from './services/advised-eligibility-validator.service';
import { CaseSetupService } from './services/case-setup.service';

const COMPONENTS = [AddCaseComponent, AdvisedResidentialQuestionsComponent, BuyToLetQuestionsComponent];

@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
  imports: [CommonModule, CommonControlsModule, RomeLibraryModule, RomeKendoModule, FormsModule],
  providers: [AdvisedEligibilityValidatorService, CaseSetupService]
})
export class CasesSetupControlsModule {}
